import Vue from 'vue';

Vue.directive('click-outside', {
  bind: function (el, binding) {
    el.eventSetDrag = function () {
      el.setAttribute('data-dragging', 'yes');
    };
    el.eventClearDrag = function () {
      el.removeAttribute('data-dragging');
    };
    el.eventOnClick = function (event) {
      var dragging = el.getAttribute('data-dragging');
      if (dragging) return;
      // Check that the click was outside the el and its children, and wasn't a drag
      if (el === event.target || el.contains(event.target)) return;

      const value = binding.value;
      const handler = typeof value === 'function' ? value : value.handler;

      const ignore = (value && value.ignore) || [];

      const clickedOnIgnored = ignore.some((selector) =>
        event.target.closest(selector)
      );

      if (clickedOnIgnored) return;

      handler(event);
    };
    document.addEventListener('touchstart', el.eventClearDrag);
    document.addEventListener('touchmove', el.eventSetDrag);
    document.addEventListener('mousedown', el.eventOnClick);
    document.addEventListener('touchend', el.eventOnClick);
  },
  unbind: function (el) {
    document.removeEventListener('touchstart', el.eventClearDrag);
    document.removeEventListener('touchmove', el.eventSetDrag);
    document.removeEventListener('mousedown', el.eventOnClick);
    document.removeEventListener('touchend', el.eventOnClick);
    el.removeAttribute('data-dragging');
  },
});
